import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from 'app/spacing';
import { getErrorComoponents } from '__components/CatchError/CatchError';
import { ErrorMessage } from '__components/ErrorMessage';
import { getSettingsAccess } from 'store/authentication/selectors';
import { BusinessBuilderContainer } from './styles';
import { Conversation, FLOW_TYPE, TASK_TYPE } from 'ts-components/Conversation';
import { useNavBarState } from 'app/navBarController';
import Loader from '__components/Kizen/Loader';
import { SAMPLE_IDEAS } from '../BusinessBuilderPublic/constants';
import { QuickResponseData } from 'ts-components/QuickResponses';

const BusinessBuilderChild: FC = () => {
  const isMobile = useBreakpoint();
  const { t } = useTranslation();
  const { height } = useNavBarState();

  const sampleIdeas = useMemo(() => {
    const ideas = SAMPLE_IDEAS(t);
    return {
      options: ideas.sort(() => 0.5 - Math.random()).slice(0, 4),
      selectType: 'single_select',
    } as QuickResponseData;
  }, [t]);

  if (!height) {
    return <Loader loading />;
  }

  return (
    <BusinessBuilderContainer navHeight={height}>
      <Conversation
        entityName={t('App')}
        flowType={FLOW_TYPE.business_builder}
        taskType={TASK_TYPE.BUSINESS_STATEGIC_PLAN_GENERATION}
        header={t('Kizen AI Business Builder')}
        isMobile={isMobile}
        showLogo
        sampleIdeas={sampleIdeas}
        renderMarkdown
      />
    </BusinessBuilderContainer>
  );
};

const BusinessBuilder: FC = () => {
  const { t } = useTranslation();
  const { aiBusinessGeneration } = useSelector(getSettingsAccess);

  if (!aiBusinessGeneration?.enabled) {
    const errorComponents = getErrorComoponents(t)[403];
    return (
      <ErrorMessage
        title={errorComponents.title}
        text={errorComponents.text}
        button={errorComponents.button}
        dashboard
        supportEmail={errorComponents.supportEmail}
        code
      />
    );
  }

  return <BusinessBuilderChild />;
};
export default BusinessBuilder;
